// hooks/usePageTracking.js
import { useEffect } from "react";

const usePageTracking = (title) => {
  useEffect(() => {
    if (title) {
      try
      {
        document.title = title;
        if (typeof window.trackEvent === 'function') {
          window.trackEvent('page_view', { page_title: title });
        }
      }catch(e)
      {

      }
    }
  }, [title]);
};

export default usePageTracking;